export default "__VITE_ASSET__DqmTv$2p__"